<div class="card overflow-hidden mt-6">
  <div class="px-gutter py-4 border-b flex flex-wrap items-center justify-between gap-4">
    <div>
      <div class="flex items-center gap-2">
        <h2 class="title m-0">Équipes ({{ (teams$ | async)?.length }})</h2>
        <team-action-mock-new [show]="settings.showNew"></team-action-mock-new>
      </div>
      <p class="m-0 caption text-secondary">Maquette : données fictives</p>
    </div>
    <button mat-raised-button color="primary" type="button" (click)="create()">
      <mat-icon class="mr-1">add</mat-icon>
      AJOUTER
    </button>
  </div>
  <team-action-mock-team-table
    [teams]="(teams$ | async) ?? []"
    [showSupport]="false"
    [linkable]="true"
  ></team-action-mock-team-table>
</div>
